export default String.raw`
.graphical-variant-popup {
    max-height: 100svh;
    height: fit-content;

    .dialog {
        &__content {
            padding: 24px 16px 0 16px;

            .chips-container .chip {
                width: 48px;
                height: 48px;
                aspect-ratio: 1/1;
            }
        }

        &__actions {
            padding: 16px 24px 24px 16px;

            button {
                width: auto;
            }
        }
    }
}
`